/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UtilityImageDTO } from './UtilityImageDTO';

export type SubmitUtilityBvnSelfieVerifyRequestDTO = {
    bvnNumber?: string;
    dateOfBirth?: string;
    images?: Array<UtilityImageDTO>;
    phoneNumber: string;
    purpose: SubmitUtilityBvnSelfieVerifyRequestDTO.purpose;
    tierStep?: SubmitUtilityBvnSelfieVerifyRequestDTO.tierStep;
    verificationType: SubmitUtilityBvnSelfieVerifyRequestDTO.verificationType;
};

export namespace SubmitUtilityBvnSelfieVerifyRequestDTO {

    export enum purpose {
        ONBOARDING = 'ONBOARDING',
        TIER_UPGRADE = 'TIER_UPGRADE',
        CORPORATE_DIRECTOR = 'CORPORATE_DIRECTOR',
        PASSCODE_RESET = 'PASSCODE_RESET',
        PASSCODE_CHANGE = 'PASSCODE_CHANGE',
        PIN_RESET = 'PIN_RESET',
        PIN_CHANGE = 'PIN_CHANGE',
        UTILITY_CHECK = 'UTILITY_CHECK',
    }

    export enum tierStep {
        START_PAGE_TIERS_STEP = 'START_PAGE_TIERS_STEP',
        SELFIE_VERIFICATION_STEP = 'SELFIE_VERIFICATION_STEP',
        NIN_VERIFICATION_STEP = 'NIN_VERIFICATION_STEP',
        NEXT_OF_KIN_STEP = 'NEXT_OF_KIN_STEP',
        DOCUMENT_VERIFICATION_STEP = 'DOCUMENT_VERIFICATION_STEP',
        BUSINESS_ADDRESS_STEP = 'BUSINESS_ADDRESS_STEP',
        REGISTRATION_DETAILS_STEP = 'REGISTRATION_DETAILS_STEP',
        BUSINESS_DETAILS_STEP = 'BUSINESS_DETAILS_STEP',
        ADDRESS_VERIFICATION_STEP = 'ADDRESS_VERIFICATION_STEP',
        DIRECTOR_DETAILS_STEP = 'DIRECTOR_DETAILS_STEP',
        PROOF_OF_ADDRESS_STEP = 'PROOF_OF_ADDRESS_STEP',
        END_PAGE_STEP = 'END_PAGE_STEP',
    }

    export enum verificationType {
        BVN_VERIFICATION = 'BVN_VERIFICATION',
        SELFIE_VERIFICATION = 'SELFIE_VERIFICATION',
        COMBINED_VERIFICATION = 'COMBINED_VERIFICATION',
    }


}
